export function formatBsb(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 6);
  if (digits.length > 3) {
    return digits.slice(0, 3) + '-' + digits.slice(3);
  }
  return digits;
}

export function validateBsb(input: string | null | undefined): boolean {
  if (!input) return true;
  const digits = input.replace(/\D/g, '');
  return digits.length === 6;
}

export function formatAccountNumber(input: string): string {
  return input.replace(/\D/g, '').slice(0, 9);
}

export function validateAccountNumber(input: string | null | undefined): boolean {
  if (!input) return true;
  const digits = input.replace(/\D/g, '');
  return digits.length >= 1 && digits.length <= 9;
}
